import { render, staticRenderFns } from "./getQuote.vue?vue&type=template&id=24326056&scoped=true"
import script from "./getQuote.vue?vue&type=script&lang=js"
export * from "./getQuote.vue?vue&type=script&lang=js"
import style0 from "./getQuote.vue?vue&type=style&index=0&id=24326056&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24326056",
  null
  
)

export default component.exports